export const GENERAL_STYLE = {
  LOGIN_CARD: {
    CLASS_NAME: 'top-[calc(50%-348px/2-82px)] left-[calc(50%-410px/2)] p-[42px] w-[456px] bg-bw00 rounded-md',
    BACKGROUND: 'bg-transparent',
  },
  HEADING: {
    CLASS_NAME: ' text-bw08  font-metricRBold text-[24px]',
  },
  DESCRIPTION: {
    CLASS_NAME: ' text-bw08 font-metricR text-[16px] whitespace-pre-line',
  },
  MAIN_BUTTON: {
    CLASS_NAME: 'self-bottom w-full',
  },
  SECONDARY_BUTTON: {
    CLASS_NAME: 'bg-gray font-metricRMedium text-action03 hover:text-action04',
  },
};
export const FORGOT_EMAIL_PAGE_DATA = {
  HEADING_TITLE: 'FORGOT_EMAIL.HEADER_TEXT',
  INPUT_TITLE: 'FORGOT_EMAIL.INPUT_TEXT',
  CONTINUE_BUTTON_TITLE: 'FORGOT_EMAIL.CONTINUE_BUTTON_TEXT',
  RECOVER_EMAIL_ERROR: 'FORGOT_EMAIL.RECOVER_EMAIL_ERROR_MESSAGE',
  RECOVER_EMAIL_ERROR_TITLE: 'FORGOT_EMAIL.RECOVER_EMAIL_ERROR_TITLE',
  SIGN_UP_BUTTON_TITLE: 'FORGOT_EMAIL.SIGN_UP_BUTTON_TITLE',
} as const;

export const FORGOT_EMAIL_SUCCESS_PAGE_DATA = {
  HEADING_TEXT: 'FORGOT_EMAIL_SUCCESS.HEADER_TEXT',
  SUBTITLE_TEXT: 'FORGOT_EMAIL_SUCCESS.SUBTITLE_TEXT',
  CONTINUE_BUTTON_TEXT: 'FORGOT_EMAIL_SUCCESS.CONTINUE_BUTTON_TEXT',
} as const;

export const FORGOT_PASSWORD_FLOW = {
  EMAIL_INPUT: {
    TITLE: 'FORGOT_PASSWORD_FLOW.EMAIL_INPUT.TITLE',
    SUBTITLE: 'FORGOT_PASSWORD_FLOW.EMAIL_INPUT.SUBTITLE',
    INPUT_TITLE: 'FORGOT_PASSWORD_FLOW.EMAIL_INPUT.INPUT_TITLE',
    FORGOT_EMAIL_BUTTON: 'FORGOT_PASSWORD_FLOW.EMAIL_INPUT.FORGOT_EMAIL_BUTTON',
    CONTINUE_BUTTON_TEXT: 'FORGOT_PASSWORD_FLOW.EMAIL_INPUT.CONTINUE_BUTTON_TEXT',
  },
  SSN_INPUT: {
    TITLE: 'FORGOT_PASSWORD_FLOW.SSN_INPUT.TITLE',
    SUBTITLE: 'FORGOT_PASSWORD_FLOW.SSN_INPUT.SUBTITLE',
    CONTINUE_BUTTON_TEXT: 'FORGOT_PASSWORD_FLOW.SSN_INPUT.CONTINUE_BUTTON_TEXT',
  },
  MFA_METHOD: {
    TITLE: 'FORGOT_PASSWORD_FLOW.MFA_METHOD.TITLE',
    SUBTITLE: 'FORGOT_PASSWORD_FLOW.MFA_METHOD.SUBTITLE',
    SMS_METHOD: 'FORGOT_PASSWORD_FLOW.MFA_METHOD.SMS_METHOD',
    CALL_METHOD: 'FORGOT_PASSWORD_FLOW.MFA_METHOD.CALL_METHOD',
  },
  CODE_VERIFICATION: {
    TITLE: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.TITLE',
    SUBTITLE: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.SUBTITLE',
    RESEND_BUTTON_TITLE: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.RESEND_BUTTON_TITLE',
    CONTINUE_BUTTON_TITLE: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.CONTINUE_BUTTON_TITLE',
    DID_NOT_GET_CODE: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.DID_NOT_GET_CODE',
    RESEND_COUNT_TEXT: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.RESEND_COUNT_TEXT',
    RESEND_COUNT_SECONDS: 'FORGOT_PASSWORD_FLOW.CODE_VERIFICATION.RESEND_COUNT_SECONDS',
  },
  NEW_PASSWORD: {
    TITLE: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.TITLE',
    RULE_1: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.RULE_1',
    RULE_2: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.RULE_2',
    RULE_3: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.RULE_3',
    INPUT_TITLE: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.INPUT_TITLE',
    PASSWORD_STRENGTH_TOO_WEAK: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.PASSWORD_STRENGTH_TOO_WEAK',
    PASSWORD_STRENGTH_WEAK: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.PASSWORD_STRENGTH_WEAK',
    PASSWORD_STRENGTH_FAIR: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.PASSWORD_STRENGTH_FAIR',
    PASSWORD_STRENGTH_STRONG: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.PASSWORD_STRENGTH_STRONG',
    CONFIRM_BUTTON_TITLE: 'FORGOT_PASSWORD_FLOW.NEW_PASSWORD.CONFIRM_BUTTON_TITLE',
  },
  SUCCESS: {
    TITLE: 'FORGOT_PASSWORD_FLOW.SUCCESS.TITLE',
    DESCRIPTION: 'FORGOT_PASSWORD_FLOW.SUCCESS.DESCRIPTION',
    CONTINUE_BUTTON_TITLE: 'FORGOT_PASSWORD_FLOW.SUCCESS.CONTINUE_BUTTON_TITLE',
  },
  ERRORS: {
    INVALID_EMAIL: 'FORGOT_PASSWORD_FLOW.ERRORS.INVALID_EMAIL',
    INVALID_CODE: 'FORGOT_PASSWORD_FLOW.ERRORS.INVALID_CODE',
    INVALID_ANSWER: 'FORGOT_PASSWORD_FLOW.ERRORS.INVALID_ANSWER',
    INPUT_STEP_ERROR_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.INPUT_STEP_ERROR_TITLE',
    INPUT_STEP_ERROR_DESCRIPTION: 'FORGOT_PASSWORD_FLOW.ERRORS.INPUT_STEP_ERROR_DESCRIPTION',
    GENERAL_ERROR_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_TITLE',
    GENERAL_ERROR_DESCRIPTION: 'FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_DESCRIPTION',
    GENERAL_ERROR_MAIN_ACTION_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_MAIN_ACTION_TITLE',
    GENERAL_ERROR_SECONDARY_ACTION_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_SECONDARY_ACTION_TITLE',
    ERROR_BUTTON_GOT_IT: 'FORGOT_PASSWORD_FLOW.ERRORS.ERROR_BUTTON_GOT_IT',
    USER_LOCKED_ERROR_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.USER_LOCKED_ERROR_TITLE',
    USER_LOCKED_ERROR_DESCRIPTION: 'FORGOT_PASSWORD_FLOW.ERRORS.USER_LOCKED_ERROR_DESCRIPTION',
    TOKEN_EXPIRED_ERROR_TITLE: 'FORGOT_PASSWORD_FLOW.ERRORS.TOKEN_EXPIRED_ERROR_TITLE',
    TOKEN_EXPIRED_ERROR_DESCRIPTION: 'FORGOT_PASSWORD_FLOW.ERRORS.TOKEN_EXPIRED_ERROR_DESCRIPTION',
  },
} as const;
